import classNames from "classnames";
import Image from "next/image";
import { Card } from "react-bootstrap";

import { LocalizedLink } from "../localized-link";
import styles from "./article-card.module.scss";
import { LanguageProps } from "@/i18n";
import { getStrapiMediaSafe } from "@/lib/strapi/media";
import { GetType } from "@/types/types";

type Microblog = GetType<"api::microblog.microblog">;

interface Props extends LanguageProps {
  article: Microblog;
}

export function ArticleCard({ article, lang }: Props) {
  return (
    <Card className={styles["blog-card"]}>
      <Image
        className={styles["head-image"]}
        width={0}
        height={0}
        sizes="100vw"
        src={getStrapiMediaSafe(
          article.cover_thumbnail?.data
            ? article.cover_thumbnail
            : article.cover,
        )}
        alt={article.headline}
      />
      <Card.Body className={styles["blog-card-body"]}>
        <Card.Subtitle
          className={classNames(styles.subtitle, styles["extra-info"])}
        >
          {(article.categories?.data ?? [])
            .map((x) => x.attributes.categorie_name)
            .join(", ")
            .toUpperCase()}
        </Card.Subtitle>
        <Card.Title className={styles.title}>
          <LocalizedLink
            href={`/article/${article.id}`}
            lang={lang}
            className="stretched-link text-decoration-none text-reset"
          >
            <h5 className="py-2">{article.headline}</h5>
          </LocalizedLink>
        </Card.Title>

        <span
          suppressHydrationWarning
          className={classNames(styles.date, styles["extra-info"])}
        >
          {new Date(article.publish_date).toLocaleString("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}
        </span>
      </Card.Body>
    </Card>
  );
}
